import React, { FC } from 'react';
import LeftPanel from './components/LeftPanel';
import ForgetPassowrdForm from './components/ForgetPassowrdForm';

const ForgetPassword: FC = () => (
  <div className='flex flex-col md:flex-row h-screen'>
    <LeftPanel />

    <div className='w-full md:w-1/2 p-10 flex flex-col items-center justify-center'>
      <h2 className='text-3xl font-semibold mb-1'>Forget Password</h2>
      <p className='text-sm text-black mb-6'>
        Don’t worry, We can figure your issue
      </p>
      <ForgetPassowrdForm />
    </div>
  </div>
);

export default ForgetPassword;
